import styled from "styled-components";
import H1 from "./H1";

const H2 = styled(H1).attrs({
  as: "h2",
})`
  font-size: ${({ size, theme }) => size || theme.fontSizes.h2};

  @media (max-width: 768px) {
    font-size: ${({ theme, size }) => size || theme.fontSizes.h3};
  }
`;

export default H2;
